module.exports = __webpack_public_path__ + "bd659125c65884506e5fc45e37f10fce.svg";